import type { GameInfo } from "@/lib/api";

/**
 * Fallback game snapshots for demo/local data. New API responses include a
 * real `game`; this only fills rows created before game scores were returned.
 */
const DEMO_GAMES: Omit<GameInfo, "status">[] = [
	{
		awayTeam: "Chicago Cubs",
		homeTeam: "St. Louis Cardinals",
		awayScore: 3,
		homeScore: 4,
		clock: "Bottom 7",
	},
	{
		awayTeam: "Los Angeles Dodgers",
		homeTeam: "New York Mets",
		awayScore: 2,
		homeScore: 2,
		clock: "Top 6",
	},
	{
		awayTeam: "New York Yankees",
		homeTeam: "Boston Red Sox",
		awayScore: 5,
		homeScore: 1,
		clock: "Bottom 8",
	},
];

function hash(value: string): number {
	let result = 0;

	for (let index = 0; index < value.length; index++) {
		result = (result * 31 + value.charCodeAt(index)) | 0;
	}

	return Math.abs(result);
}

export function demoGame(seed: string): GameInfo {
	const game = DEMO_GAMES[hash(seed) % DEMO_GAMES.length];

	return { ...game, status: "live" };
}
